'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lib = {};

exports.__exports = lib;
